// libraries
import React, { useState } from "react";

// styles
import styles from "./styles.module.scss";

const Feedback = ({ toggleFeedback }) => {
  // states
  const [radioValue, setRadioValue] = useState("");

  return (
    <div className={styles.feedback}>
      <div>
        <h3>Feedback</h3>
        <form>
          <label>
            <input
              type="radio"
              checked={radioValue === "Inappropriate Event" ? true : false}
              onChange={(e) => {
                setRadioValue(e.target.value);
              }}
              value="Inappropriate Event"
            />
            Inappropriate Event
          </label>
          <label>
            <input
              type="radio"
              checked={radioValue === "Event Support" ? true : false}
              onChange={(e) => setRadioValue(e.target.value)}
              value="Event Support"
            />
            Event Support
          </label>
          <label>
            <input
              type="radio"
              checked={radioValue === "Bugs" ? true : false}
              onChange={(e) => setRadioValue(e.target.value)}
              value="Bugs"
            />
            Bugs
          </label>
          <label>
            <input
              type="radio"
              checked={radioValue === "Event listed in a error" ? true : false}
              onChange={(e) => setRadioValue(e.target.value)}
              value="Event listed in a error"
            />
            Event listed in a error
          </label>
          <label>
            <input
              type="radio"
              checked={radioValue === "Investor relations" ? true : false}
              onChange={(e) => setRadioValue(e.target.value)}
              value="Investor relations"
            />
            Investor relations
          </label>
          <label>
            <input
              type="radio"
              checked={
                radioValue === "Become Eventmoon Promoter" ? true : false
              }
              onChange={(e) => setRadioValue(e.target.value)}
              value="Become Eventmoon Promoter"
            />
            Become Eventmoon Promoter
          </label>
          <label>
            <input
              type="radio"
              checked={
                radioValue === "Become Eventmoon a affiliate" ? true : false
              }
              onChange={(e) => setRadioValue(e.target.value)}
              value="Become Eventmoon a affiliate"
            />
            Become Eventmoon a affiliate
          </label>
          <label className={styles.desc}>
            Description
            <textarea placeholder="Write your description"></textarea>
          </label>
          <span>
            <button onClick={toggleFeedback}>Cancel</button>
            <button
              type="submit"
              onClick={(e) => {
                e.preventDefault();
                toggleFeedback();
              }}
            >
              Submit
            </button>
          </span>
        </form>
      </div>
    </div>
  );
};

export default Feedback;
